var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdcardicon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93702 0.97644C3.36923 0.97644 2.06201 2.23878 2.06201 3.85143C2.06201 4.46551 2.24678 5.01231 2.60028 5.52494L4.71702 8.82821C4.81954 8.98841 5.05448 8.98841 5.15701 8.82821L7.28337 5.51321C7.62939 5.02407 7.81201 4.44949 7.81201 3.85143C7.81201 2.26655 6.52297 0.97644 4.93702 0.97644ZM4.93702 5.15863C4.21614 5.15863 3.62982 4.57231 3.62982 3.85143C3.62982 3.13054 4.21614 2.54422 4.93702 2.54422C5.65791 2.54422 6.24423 3.13054 6.24423 3.85143C6.24423 4.57231 5.65791 5.15863 4.93702 5.15863Z",
    fill: "#E31F25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdcardicon1);
export default __webpack_public_path__ + "static/media/idcardicon1.a3eccb226d42a1b7278706aafb8d964a.svg";
export { ForwardRef as ReactComponent };